import { getConfigManager } from '../../config';
import { MULTICALL_CONTRACT_ADDRESS } from '../../constants';
import { Decimal, DEFAULT_DECIMAL_PRECISION } from '../../datastructures';
import { NostraToken } from '../../interfaces';
import { MultiCallContract } from '../../services';
import nostraTokenListAtom from './nostraTokenListAtom';
import { createAsyncAtom } from '../../lib/state';
import { RpcProvider } from 'starknet';
import rpcProviderAtom from '../rpcProviderAtom';

interface DebtData {
  debtFactor: Decimal;
}

export type DebtDataMap = { [debtTokenAddress: string]: DebtData };

const fetchData = async (debtTokens: NostraToken[], provider: RpcProvider) => {
  try {
    const config = getConfigManager().getConfig();

    try {
      const RESPONSE_CHUNK_SIZE = 6;

      const calldata = debtTokens.map(debtToken => {
        return {
          contractAddress: config.cdpManager,
          entrypoint: 'debt_data',
          calldata: [debtToken.address],
        };
      });

      const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

      const result = await multiCallContract.aggregate(calldata);
      if (!result) {
        return null;
      }

      const debtDataMap: DebtDataMap = {};

      for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
        // Index 3 and 4 are low and high BNs for debtFactor
        const debtFactor = new Decimal({ low: result[i + 3], high: result[i + 4] }, DEFAULT_DECIMAL_PRECISION);

        debtDataMap[debtTokens[i / RESPONSE_CHUNK_SIZE].address] = {
          debtFactor,
        };
      }

      return debtDataMap;
    } catch (error) {
      console.warn('Failed to getDebtData using v2, trying v1...');

      const RESPONSE_CHUNK_SIZE = 7;

      const calldata = debtTokens.map(debtToken => {
        return {
          contractAddress: config.cdpManager,
          entrypoint: 'getDebtData',
          calldata: [debtToken.address],
        };
      });

      const multiCallContract = new MultiCallContract(MULTICALL_CONTRACT_ADDRESS, provider);

      const result = await multiCallContract.aggregate(calldata);
      if (!result) {
        return null;
      }

      const debtDataMap: DebtDataMap = {};

      for (let i = 0; i < result.length; i += RESPONSE_CHUNK_SIZE) {
        // Index 4 and 5 are low and high BNs for debtFactor
        const debtFactor = new Decimal({ low: result[i + 4], high: result[i + 5] }, DEFAULT_DECIMAL_PRECISION);

        debtDataMap[debtTokens[i / RESPONSE_CHUNK_SIZE].address] = {
          debtFactor,
        };
      }

      return debtDataMap;
    }
  } catch (error) {
    console.error(`useDebtData - Failed to load debt data!`, error);
    return null;
  }
};

const debtDataAtom = createAsyncAtom(async get => {
  const nostraTokens = await get(nostraTokenListAtom);
  const provider = await get(rpcProviderAtom);

  const nostraDebtTokens = nostraTokens.filter(nostraToken => nostraToken.variant === 'debt');

  return fetchData(nostraDebtTokens, provider);
});
export default debtDataAtom;
